import { AfterViewInit, Component, Input } from '@angular/core';
import { CtExportConfiguration, CtModelConfiguration, CtModelOperator, CtModelType, MAT_RAISED_PRIMARY } from '@ctsolution/ct-framework';
import { TaskRouteData } from '../../../_core/route-data/task.route-data';
import { DEFAULT_DATATABLE_CONFIGURATION } from '../../../_core/constants';
import { TaskListConfiguration } from './task-list.configuration';
import { Router } from '@angular/router';
import { CtManagerService } from '../../../_core/lib/ct-manager.service';
import { CTConfigurationModel } from '../../../_core/classes/ct-configuration-model';

@Component({
  selector: 'app-task-list',
  templateUrl: './task-list.component.html',
  styleUrls: ['./task-list.component.scss']
})
export class TaskListComponent implements AfterViewInit {

  configuration: CtModelConfiguration<any> | null = null;
  @Input() taskListConfiguration: TaskListConfiguration | null = null;
  taskConfiguration: CTConfigurationModel = CTConfigurationModel.create().setVisible(true);

  constructor(private router: Router, private managerService: CtManagerService) { }

  ngAfterViewInit() {

    this.setup();

  }

  async setup() {

    // ✅ FIX ExpressionChangedAfterItHasBeenCheckedError
    // Assegniamo la configuration con setTimeout (macrotask) per evitare l'errore
    await new Promise(resolve => setTimeout(resolve, 0));

    await this.managerService.getComponentOverride("task", "taskConfiguration", this.taskConfiguration).then((component) => {
      return;
    });

    const configuration = CtModelConfiguration.create()
      .setRouteData(TaskRouteData().setModelType(CtModelType.DATATABLE))
      .setCTDatatableConfiguration(DEFAULT_DATATABLE_CONFIGURATION())
      .setDisableAutoQueryFilter(false);

    if (this.taskConfiguration.exportExcelEnabled){

      configuration
      .setOperations([
        CtModelOperator.Update,
        CtModelOperator.Create,
        CtModelOperator.Export  // ✅ AGGIUNTO: Abilita operazione export
      ]) 
      .setExportConfiguration(
            CtExportConfiguration
              .create()
              // Action backend (corrisponde a quella in downloadExcel())
              .setAction('ExportExcel_Task')
              // Label bottone (corrisponde a exportDownloadAttachmentButton)
              .setLabel('Esporta')
              // Icona bottone (corrisponde a exportDownloadAttachmentButton)
              .setIcon('download')
              // Nome file per il download (senza estensione)
              .setFileName('Export_Progetti')
              // Colore bottone blu (corrisponde a exportDownloadAttachmentButton)
              .setMaterialOptions(MAT_RAISED_PRIMARY)
              // Esporta tutti i record ignorando la paginazione (default: false)
              // Corrisponde al comportamento di downloadExcel() che fa setPagination(null)
              .setIncludePagination(false)
          )

    }



    if (this.taskListConfiguration?.Filters)
      this.taskListConfiguration?.Filters.forEach(filter => {
        configuration
          .filterValues
          .addConstantFilter(filter)
      });

    configuration
      .setOnCreate(() => this.onCreate())
      .setOnEdit((Event: any) => this.onEdit(Event))

    if (this.taskListConfiguration?.onlyUpdate)
      configuration
        .initialized()
        .subscribe(() => configuration?.setOperations([CtModelOperator.Update]));

    this.configuration = configuration;


  }


  async onCreate() {

    if (this.taskListConfiguration?.Action) {
      await this.taskListConfiguration.Action(null)
      if (this.taskListConfiguration.navigatePostAction == false) return;

    }

    let queryParams: any = null;

    if (this.taskListConfiguration?.param) {

      queryParams = {
        TypeExtra: this.taskListConfiguration.param.Type,
        OidExtra: this.taskListConfiguration.param.Oid
      };

    }


    this.router.navigate(['task', 'create'], {
      queryParams: queryParams
    })

  }

  async onEdit(Event: any) {

    if (this.taskListConfiguration?.Action)
      await this.taskListConfiguration.Action(null)

    let queryParams: any = null;

    if (this.taskListConfiguration?.param) {

      queryParams = {
        TypeExtra: this.taskListConfiguration.param.Type,
        OidExtra: this.taskListConfiguration.param.Oid,
        IdEvent: Event.Oid
      };

    }

    this.router.navigate(['task', 'edit', Event.Oid], {
      queryParams: queryParams
    })

  }

}

